export const noteKeys = {
  all: () => ["bookingNotes"],
  ofBooking: (bookingId: number, perPage?: number) => {
    const key = [...noteKeys.all(), bookingId];
    perPage !== undefined && key.push(perPage);
    return key;
  },
  remove: (noteId: number) => [...noteKeys.all(), noteId, "remove"],
  create: () => [...noteKeys.all(), "create"],
  update: (noteId: number) => [...noteKeys.all(), noteId, "update"]
};
